<script setup lang="ts">
import { computed } from "vue";
import TagItem from "@/components/Reusables/Utils/TagItem.vue";

const props = defineProps<{
  source: number;
}>();

const origin = computed(() => {
  if (props.source === 0) return "Speckle";
  if (props.source === 1) return "Custom";
  if (props.source === 2) return "Combined";
  if (props.source === 3) return "Epd";
  if (props.source === 4) return "Excel upload";
  if (props.source === 5) return "Forma";
  else return "";
});
</script>

<template>
  <TagItem
    v-if="origin.length > 0"
    color="label"
    :label="origin" />
</template>
